import { useState, useEffect } from 'react';
import { loadVidyardScript } from './vidyardLoader';
import { Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useOnboarding } from '../../context/OnboardingContext';
import {
  StyledDialog,
  StepContent,
  ImageContainer,
  NavigationContainer,
  StepIndicators,
  StepDot
} from './Onboarding.styles';
import {Steps} from './Steps';

export function OnboardingModal() {
  const { isOpen, closeModal } = useOnboarding();
  const [currentStep, setCurrentStep] = useState(0);

  useEffect(() => {
    if (isOpen) {
      setCurrentStep(0);
      loadVidyardScript().catch(console.error);
    }
  }, [isOpen]);

  const handleNext = () => {
    if (currentStep < Steps.length - 1) {
      setCurrentStep(prev => prev + 1);
    }
  };

  const handlePrevious = () => {
    if (currentStep > 0) {
      setCurrentStep(prev => prev - 1);
    }
  };

  return (
    <StyledDialog
      open={isOpen}
      onClose={closeModal}
      maxWidth="md"
      fullWidth
    >
      <IconButton
        onClick={closeModal}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
        }}
      >
        <CloseIcon />
      </IconButton>

      <StepContent>
        <Typography variant="h4" component="h2" gutterBottom>
          {Steps[currentStep].title}
        </Typography>

        {Steps[currentStep].video ? (
            // Render the video JSX element if present
            Steps[currentStep].video
        ) : (
            // Otherwise, if an image URL exists, render the image
            Steps[currentStep].imageUrl && (
                <ImageContainer>
                <img
                    src={Steps[currentStep].imageUrl}
                    alt={Steps[currentStep].title}
                />
                </ImageContainer>
            )
        )}

        <Typography variant="body1" color="text.secondary" sx={{ maxWidth: '460px', mb: 3 }}>
          {Steps[currentStep].description}
        </Typography>

        <NavigationContainer>
          <IconButton
            onClick={handlePrevious}
            disabled={currentStep === 0}
          >
            <ChevronLeftIcon />
          </IconButton>
          <StepIndicators>
          {Steps.map((step, index) => (
            <StepDot key={step.number} active={currentStep === index} />
          ))}
        </StepIndicators>
          <IconButton
            onClick={handleNext}
            disabled={currentStep === Steps.length - 1}
          >
            <ChevronRightIcon />
          </IconButton>
        </NavigationContainer>
      </StepContent>
    </StyledDialog>
  )
}
